import { offlineConversions, uetTags, conversionGoals } from '../configs/tools/conversion-tracking';

export const conversions = {
  id: 'conversions',
  name: _TL_('Conversions'),
  description: _TL_('Get behavioral insights for conversion tracking.'),
  children: [
    uetTags,
    conversionGoals,
    offlineConversions,
  ],
};
